import React, { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { meetingApi, meetingInvitationKey, pendingMeetingInvitation } from "./meetingApi";
import "./Services.css";
import "./Meetings.css";

export default function MeetingInvitation({ loggedIn, onLogin, onCreateAccount }) {
  const location = useLocation(); const navigate = useNavigate();
  const [invitation] = useState(() => {
    const token = new URLSearchParams(location.hash.slice(1)).get("token");
    return /^[a-f0-9]{32}$/.test(token) ? { token, expires: Date.now() + 7 * 86400000, autoJoin: false } : pendingMeetingInvitation();
  });
  const [error, setError] = useState(""); const [busy, setBusy] = useState(false);
  const running = useRef(false);
  useEffect(() => {
    if (invitation) sessionStorage.setItem(meetingInvitationKey, JSON.stringify(invitation));
  }, [invitation]);
  useEffect(() => {
    if (location.hash) navigate("/meetings/invite", { replace: true });
  }, [location.hash, navigate]);
  async function join() {
    if (running.current || !invitation) return;
    running.current = true; setBusy(true); setError("");
    try {
      const result = await meetingApi("/join", "POST", { token: invitation.token });
      sessionStorage.removeItem(meetingInvitationKey);
      navigate(`/meetings?meeting=${encodeURIComponent(result.meetingId)}`, { replace: true });
    } catch (reason) { setError(reason.message || "The invitation could not be accepted. Please retry."); }
    finally { running.current = false; setBusy(false); }
  }
  useEffect(() => {
    if (loggedIn && invitation?.autoJoin) join();
    // Resume only the explicit join action saved before login/account creation.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loggedIn, invitation]);
  function authenticate(create) {
    sessionStorage.setItem(meetingInvitationKey, JSON.stringify({ ...invitation, autoJoin: true }));
    if (create) onCreateAccount(); else onLogin();
  }
  return <main className="service-monitor-page meetings-page"><div className="service-monitor-inner">
    <section className="service-monitor-panel meeting-section"><h1>Join a meeting analysis</h1>
      {!invitation ? <p>This invitation is missing or expired. Open the link in your invitation email or ask the meeting creator to resend it.</p>
        : <><p>Use the email address that received this invitation. Joining shares your name, email, Signal Score and workspace, network and device status with the meeting creator and other joined participants. Joined participants can request individual or full-meeting analyses and view live telemetry while an analysis runs. The requester pays for their analyses. Joining does not bypass your device's analysis approval settings.</p>
          {loggedIn ? <button type="button" disabled={busy} onClick={join}>{busy ? "Joining..." : "Join meeting"}</button>
            : <div className="meeting-actions"><button type="button" onClick={() => authenticate(false)}>Sign in and join</button>
              <button type="button" onClick={() => authenticate(true)}>Create account and join</button></div>}
        </>}
      {error && <p role="alert">{error}</p>}
    </section>
  </div></main>;
}
